import {Conversation} from '@stripe-internal/conversations-client';
import {LiveChatTopBar, useWidget} from '@stripe-internal/conversations-ui';
import {useLayoutEffect} from 'react';
import {useActiveBottomDrawer} from './useActiveBottomDrawer';
import {useLiveChannelStatus} from './useLiveChannelStatus';
import {useNewDesignsEnabled} from './useNewDesignsEnabled';
import {RACTopBar} from './RACTopBar';

export const useConversationTopBar = (conversation: Conversation) => {
  const {header} = useWidget();
  const newDesignsEnabled = useNewDesignsEnabled();
  const {isLiveChatActive, isRACActive, agentNames} = useLiveChannelStatus({
    conversation,
  });
  const {activeBottomDrawer} = useActiveBottomDrawer({
    conversation,
  });

  useLayoutEffect(() => {
    if (!newDesignsEnabled) {
      return;
    }

    // Hide the top bar when we're showing the close confirmation screen
    if (isLiveChatActive && activeBottomDrawer !== 'closeConfirmation') {
      header.setTopBar(<LiveChatTopBar agentNames={agentNames} />);
    } else if (isRACActive) {
      header.setTopBar(<RACTopBar conversation={conversation} />);
    } else {
      header.setTopBar(null);
    }
  }, [
    header,
    newDesignsEnabled,
    isLiveChatActive,
    isRACActive,
    agentNames,
    conversation,
    activeBottomDrawer,
  ]);
};
